// Allows for smooth scrolling in safari.
// _body.scss has the style for controlling the scroll behaviour
import smoothscroll from '.pnpm/smoothscroll-polyfill@0.4.4/node_modules/smoothscroll-polyfill';
import 'smoothscroll-anchor-polyfill';
smoothscroll.polyfill();
